import { render, staticRenderFns } from "./LoginBodega.vue?vue&type=template&id=4bb10a7f&scoped=true"
import script from "./LoginBodega.vue?vue&type=script&lang=js"
export * from "./LoginBodega.vue?vue&type=script&lang=js"
import style0 from "./LoginBodega.vue?vue&type=style&index=0&id=4bb10a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb10a7f",
  null
  
)

export default component.exports